import {gaConfig} from '@stencil/hotels-config';
import {
  BaseColumnWrap,
  SmallSectionHeader,
} from '../../../../../stories/components/CommonStyleUtils/dwebCommon.styles';
import {
  checkinFormattedTimeFromStaticData as checkinFormattedTimeFromStaticDataFn,
  checkoutFormattedTimeFromStaticData as checkoutFormattedTimeFromStaticDataFn,
  categorizedAmenitiesSelector,
} from '@stencil/hotels-details-reducer/src/selectors';
import detailsPageClickGaPush from '@stencil/hotels-utils/src/details-page-click-ga-push';
import React from 'react';
// HOOKS
import {useSelector} from 'react-redux';
import AmenitiesIconSelector from '../../../../components/AmenitiesIconSelector';
import {timeFormat} from '../../utils/details-page-utils';
import * as S from './styles/UGCChipsCard.styles';

const {DetailsGAClickEventActions} = gaConfig;

type UGCPersuasionHeadingType = {children: string};
const UGCPersuasionHeading: React.FC<UGCPersuasionHeadingType> = ({children}) => (
  <S.UGCPersuasionHeadingContainer>
    <S.Text_Heading_UGCPersuasion>{children}</S.Text_Heading_UGCPersuasion>
  </S.UGCPersuasionHeadingContainer>
);

type ChipDataType = {name: string; id: string};
type ChipsType = {chips: Array<ChipDataType>; onChipClick: Function; id: string};
const Chips: React.FC<ChipsType> = ({chips, onChipClick, id}) => {
  return (
    <S.ChipsContainer>
      <S.ChipsList>
        {chips.map((chipData, i) => {
          return (
            <>
              {chipData.name ? (
                <li key={`${chipData}-${i}`} title={chipData.name}>
                  <S.ChipText
                    onClick={() => {
                      if (id === 'guests-like') {
                        detailsPageClickGaPush({
                          eventAction: DetailsGAClickEventActions.whatGuestsLikeClick,
                        });
                      }

                      if (id === 'you-should-know') {
                        detailsPageClickGaPush({
                          eventAction: DetailsGAClickEventActions.whatYouShouldKnowClick,
                        });
                      }

                      if (chipData.name.includes('more')) {
                        onChipClick();
                      } else {
                        onChipClick(chipData.id);
                      }
                    }}
                  >
                    {chipData.name}
                  </S.ChipText>
                </li>
              ) : (
                ''
              )}
            </>
          );
        })}
      </S.ChipsList>
    </S.ChipsContainer>
  );
};

const AmenityChips = ({chips, onChipClick, checkInTime, checkoutTime}) => {
  let amenitiesChipsToDisplay = chips.slice(0, 4);
  const categorizedAmenities = useSelector(categorizedAmenitiesSelector);
  let totalLength = 0;
  for (let index in categorizedAmenities) {
    totalLength =
      totalLength +
      (categorizedAmenities[index] && categorizedAmenities[index].data
        ? categorizedAmenities[index].data.length
        : 0);
  }

  return (
    <BaseColumnWrap>
      <S.AmenitiesList>
        {amenitiesChipsToDisplay.map((item, index) => {
          return (
            <li key={`${item}-${index}`}>
              <AmenitiesIconSelector name={item} />
              <S.AmenitiesText>{item}</S.AmenitiesText>
            </li>
          );
        })}
      </S.AmenitiesList>
      {/* {chips.length > amenitiesChipsToDisplay.length && ( */}
      {amenitiesChipsToDisplay.length < totalLength && (
        <S.ViewAllAmenities
          onClick={() => {
            detailsPageClickGaPush({
              eventAction: DetailsGAClickEventActions.TopViewAllAmenitiesClicked,
            });
            onChipClick();
          }}
        >
          View all amenities
        </S.ViewAllAmenities>
      )}
      <S.CheckInCheckOutContainer>
        <S.CheckInCheckOutInner>
          <S.CheckInCheckOutLabel>Check-in</S.CheckInCheckOutLabel>
          <SmallSectionHeader>{checkInTime}</SmallSectionHeader>
        </S.CheckInCheckOutInner>
        <S.CheckInCheckOutInner>
          <S.CheckInCheckOutLabel>Check-out</S.CheckInCheckOutLabel>
          <SmallSectionHeader>{checkoutTime}</SmallSectionHeader>
        </S.CheckInCheckOutInner>
      </S.CheckInCheckOutContainer>
    </BaseColumnWrap>
  );
};

export type UGCCardProps = {
  heading: string;
  chips: Array<ChipDataType | string>;
  onChipClick: Function;
  type: string;
  id?: string;
};

//Type-guard for chip data type
function isChipDataType(arg: ChipDataType | string): arg is ChipDataType {
  return (
    typeof (arg as ChipDataType).name === 'string' && typeof (arg as ChipDataType).id === 'string'
  );
}

//Type-guard for chip data array
function isChipObjArray(arg: Array<ChipDataType | string>): arg is Array<ChipDataType> {
  return (arg as Array<ChipDataType>).every(item => isChipDataType(item));
}

const UGCCard: React.FC<UGCCardProps> = ({heading, chips, onChipClick, type, id}) => {
  const checkInTime = useSelector(checkinFormattedTimeFromStaticDataFn) || '';
  const checkoutTime = useSelector(checkoutFormattedTimeFromStaticDataFn) || '';

  return (
    <S.UGCCardContainer>
      <UGCPersuasionHeading>{heading}</UGCPersuasionHeading>
      {type === 'amenity' && (
        <AmenityChips
          chips={chips}
          onChipClick={onChipClick}
          checkInTime={checkInTime}
          checkoutTime={checkoutTime}
        />
      )}
      {chips && isChipObjArray(chips) && type === 'review' && (
        <Chips chips={chips} onChipClick={onChipClick} id={id} />
      )}
    </S.UGCCardContainer>
  );
};

export default UGCCard;
